import { render, staticRenderFns } from "./NavbarMain.vue?vue&type=template&id=563509a3&"
import script from "./NavbarMain.vue?vue&type=script&lang=js&"
export * from "./NavbarMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports